module.exports = __webpack_public_path__ + "static/media/computer-girl.610f183a.svg";